<div class="organization-modal modal-content" piqetAngularDraggables>
  <div class="modal-header header-modal">
    <span class="bootstrap-dialog-title">{{ modalLabel }} </span>

    <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
      <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
    </button>
  </div>

  <div class="modal-body">
    <form
      [formGroup]="equivalancyUnitsAddEditForm"
      [ngClass]="{ 'disabled-popup': !checkEntireAccess }"
    >
      <div class="row">
        <div>
          <span *ngIf="!isImageValid" id="PiqetValidationSummary" class="input-error"
            >Only .jpg,.png,.jpeg,.gif file allowed</span
          >
        </div>
        <div>
          <span *ngIf="imageSizeMax" id="PiqetValidationSummary" class="input-error"
            >Not more than 4 MB allowed</span
          >
        </div>
        <div class="col-sm-3">
          <div class="form-group">
            <label
              *ngIf="equivalancyUnitsAddEditForm.get('organizationName')?.value"
              class="sub-header-drpdown pb-2"
              >Organization</label
            >
            <ng-select
              [clearable]="true"
              [clearOnBackspace]="false"
              #organization
              [items]="organizationlist"
              [searchable]="false"
              bindLabel="name"
              formControlName="organizationName"
              placeholder="All organization"
              [readonly]="isDisableDropDown"
            >
              <ng-template ng-header-tmp>
                <div class="has-feedback">
                  <input
                    type="text"
                    class="form-control accordion-search search-input"
                    id="inputValidation"
                    placeholder="Search..."
                    (input)="organization.filter($any($event.target).value)"
                  />
                  <span class="form-control-feedback">
                    <i class="fa fa-search icon"></i>
                  </span>
                </div>
              </ng-template>
              <ng-template ng-optgroup-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item?.name }}</div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>
    </form>
    <form [formGroup]="imageInfoForm" [ngClass]="{ 'disabled-popup': !checkEntireAccess }">
      <div class="row form-group">
        <ng-container *ngFor="let formData of indicatorList; let i = index">
          <div class="col-sm-3">
            <div class="form-group" aria-required="true">
              <label>{{ formData.name }} ({{ formData.unit }})</label>
            </div>
          </div>
          <div class="col-sm-9 equivalencyUnits">
            <div class="col-sm-3 form-group">
              <input
                type="text"
                [formControlName]="formData.name"
                class="valid"
                [(ngModel)]="formData.equivalencyUnits"
              />
              <div
                *ngIf="
                  submitted ||
                  (imageInfoForm.get(formData.name)?.invalid &&
                    imageInfoForm.get(formData.name)?.touched)
                "
              >
                <div
                  *ngIf="imageInfoForm.get(formData.name)?.errors?.['required']"
                  class="input-error"
                >
                  Equivalency unit is required.
                </div>
              </div>
            </div>
            <div class="col-sm-5 form-group">
              <div class="fileinput fileinput-new">
                <div class="input-group input-large">
                  <div
                    class="form-control uneditable-input d-flex justify-content-flex-start align-items-center text-decoration-underline"
                    data-trigger="fileinput"
                    (click)="hiddenfileinput.click()"
                  >
                    <i
                      class="fa fa-file fileinput-exists"
                      *ngIf="formData.selectedFiles && isImageValid"
                    ></i>
                    <span
                      class="fileinput-filename"
                      *ngIf="formData.selectedFiles"
                      [title]="this.selectedFiles"
                      >&nbsp;{{ isImageValid ? formData.selectedFiles : '' }}</span
                    >
                  </div>
                  <span class="btn default btn-file">
                    <input
                      type="file"
                      (change)="fileChangeEvent(formData, $event)"
                      style="display: none"
                      #hiddenfileinput
                    />
                    <button
                      *ngIf="!formData.selectedFiles || !isImageValid"
                      style="
                        padding: 0px;
                        color: white;
                        width: 120px !important;
                        border-radius: 0px;
                      "
                      (click)="hiddenfileinput.click()"
                      class="waves-effect waves-light btn"
                    >
                      Select image
                    </button>
                    <button
                      *ngIf="formData.selectedFiles && isImageValid"
                      style="
                        padding: 0px;
                        color: white;
                        width: 100px !important;
                        border-radius: 0px;
                      "
                      (click)="hiddenfileinput.click()"
                      class="waves-effect waves-light btn"
                    >
                      Change
                    </button>
                  </span>
                  <button
                    (click)="removeImage(formData, hiddenfileinput)"
                    *ngIf="formData.selectedFiles && isImageValid"
                    class="waves-effect waves-light waves-Dark btn"
                  >
                    Remove
                  </button>
                </div>
              </div>
            </div>
            <div class="col-sm-1 selectedFilesSpace">
              <img
                [src]="formData.selectedFiles ? formData.imageUrl : formData.equivalencyImage"
                width="50"
                height="50"
              />
            </div>
            <form [formGroup]="lastFieldFrom">
              <div class="col-sm-12 selectedFilesSpace">
                <input type="text" [formControlName]="formData.name" class="valid" />
                <div
                  *ngIf="
                    submitted ||
                    (lastFieldFrom.get(formData.name)?.invalid &&
                      lastFieldFrom.get(formData.name)?.touched)
                  "
                >
                  <div
                    *ngIf="lastFieldFrom.get(formData.name)?.errors?.['required']"
                    class="input-error"
                  >
                    Multiplier is required.
                  </div>
                </div>
              </div>
            </form>
          </div>
        </ng-container>
      </div>
    </form>
  </div>
  <div class="modal-footer text-margin">
    <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
    <button
      type="button"
      class="modelBtn purpleBtnHoverEffect"
      *ngIf="checkEntireAccess"
      (click)="onSave()"
    >
      Save
    </button>
  </div>
</div>
